export default "__VITE_ASSET__DgFHL1wo__"